package com.arena_web.domain.usecases.auth

import com.arena_web.data.dto.AuthResponse
import com.arena_web.utils.Storage
import com.arena_web.utils.StorageKeys

fun saveAuthSession(response: AuthResponse) {
    Storage.save(StorageKeys.ACCESS_TOKEN, response.accessToken)
    Storage.save(StorageKeys.REFRESH_TOKEN, response.refreshToken)
    Storage.save(StorageKeys.USER_ID, response.user.id)
    Storage.save(StorageKeys.USER_EMAIL, response.user.email)
    Storage.save(StorageKeys.USERNAME, response.user.username)
    response.user.fullName?.let { Storage.save(StorageKeys.FULL_NAME, it) }
    response.user.avatarUrl?.let { Storage.save(StorageKeys.AVATAR_URL, it) }
}
